import React, { useContext, useMemo } from "react";
import { TextButton } from "@SeemplicityDev/shared";
import { pagesPerMenuItem } from "../EOYUtils";
import { AppPreferencesContext } from "../../General/AppPreferencesProvider";
import { AppPreferencesContextType } from "../../types/AppPreferencesProvider";

interface ProgressMenuProps {
  currentPageKey: string;
  goToPage: (page: string) => void;
}

const ProgressMenu: React.FC<ProgressMenuProps> = ({
  currentPageKey,
  goToPage,
}) => {
  const {
    appPreferences: { useAI },
  } = useContext(AppPreferencesContext) as AppPreferencesContextType;

  const activeItemIndex = useMemo(
    () =>
      Object.values(pagesPerMenuItem)?.findIndex((pages) =>
        pages.includes(currentPageKey)
      ),
    [currentPageKey]
  );

  const menuItems = useMemo(() => {
    return Object.keys(pagesPerMenuItem).reduce((acc: string[], page) => {
      if (page === "Accomplishments") {
        if (useAI) {
          acc.push("Accomplishments");
        }
      } else {
        acc.push(page);
      }
      return acc;
    }, [] as string[]);
  }, [pagesPerMenuItem, useAI]);

  return (
    <div className={"progress-menu-container"}>
      {menuItems?.map((page, index) => {
        return (
          <div
            key={index}
            className={`progress-menu-item ${activeItemIndex === index ? "active" : ""}`}
          >
            <TextButton
              className={"progress-menu-item-title"}
              onClick={() => goToPage(page)}
              label={page}
              buttonStyle={"textLink"}
            />
          </div>
        );
      })}
    </div>
  );
};

export default ProgressMenu;
